import React, {useState, useMemo, useEffect} from "react"
import {useDispatch, useStore} from "../Store"
import {useTranslation} from "react-i18next"
import "../i18n"
import VirtualSelect from "../components/VirtualSelect"
import {useCookies} from "react-cookie"
import {useOnUpdate} from "../hooks"
import {loadBaseDate} from "../lib/LoadValues"

export default function SelectTarget({id = null}) {
  const {t} = useTranslation()
  const {dispatch} = useDispatch()
  const [cookies] = useCookies([])
  const [key, setKey] = useState(false)
  const {
    store: {locale, perspective, mainTarget, mainTerm, mainType, mainGroup, mainList},
  } = useStore()

  const isFx = mainType[perspective] === `FX` || mainType[perspective] === `FXSET`

  /**
   * 変更時イベント
   * @param {Object} value - 選択値
   */
  const handleChange = async (value) => {
    if (!value) {
      mainTarget[perspective].key = null
      mainTarget[perspective].label = ``
      mainTarget[perspective].labelEn = ``
      mainTarget[perspective].labelJa = ``
      dispatch({
        type: `SET_MAIN_TARGET`,
        mainTarget,
      })
      return
    }
    mainTarget[perspective].key = value.code
    mainTarget[perspective].label = locale === `ja` ? value?.labelJa : value?.labelEn
    mainTarget[perspective].labelJa = value?.labelJa ?? ``
    mainTarget[perspective].labelEn = value?.labelEn ?? ``
    dispatch({
      type: `SET_MAIN_TARGET`,
      mainTarget,
    })

    let group = mainGroup[perspective]
    let term = mainTerm[perspective].key
    let code = mainTarget[perspective].key
    await loadBaseDate(group, term, code, cookies, dispatch)
  }

  // ロケール変更時のラベル変更
  useEffect(() => {
    if (!mainTarget[perspective]?.label)
      return

    const v = locale === `ja`
      ? mainTarget[perspective].labelJa
      : mainTarget[perspective].labelEn

    mainTarget[perspective].label = v

    dispatch({
      type: `SET_MAIN_TARGET`,
      mainTarget,
    })
    
    // ラベルテキストが即時変更できないため遅延変更する
    if (id)
      setTimeout(() => {
        document.getElementById(id).value = v
      }, 100)
  }, [locale])

  const label = isFx ? t(`targetFx`) : t(`targetEquity`)
  return useMemo (() => (
    <VirtualSelect
      id={id}
      key={key}
      required={true}
      target={`target`}
      label={locale === `ja` ? `labelJa` : `labelEn`}
      inputLabel={label}
      options={mainList[perspective]}
      onChange={handleChange}
      value={mainTarget[perspective]}
    />
  ), [locale, mainList, mainTarget, perspective])
}
